import styled from 'foundations-theming/utils';
import classNames from 'classnames';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITextToolbarButton from 'rich-text-lib/components/editor/UITextToolbarButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const RTE_TOOLBAR_BUTTON_CLASS = 'rte-toolbar-button';
export const RTEToolbarButton = props => {
  return /*#__PURE__*/_jsx(UITextToolbarButton, Object.assign({}, props, {
    className: classNames(props.className, RTE_TOOLBAR_BUTTON_CLASS)
  }));
};
const StyledTextToolbarLoadingButton = styled(UILoadingButton).withConfig({
  displayName: "StyledTextToolbarButton__StyledTextToolbarLoadingButton",
  componentId: "sc-5iht7m-0"
})(["background-color:transparent !important;padding:6px 5px !important;&:hover{border:1px solid ", " !important;}&&[aria-disabled='true']{background-color:transparent !important;border:none;&:hover{border:none !important;}}"], ({
  theme
}) => theme.color['do-not-use-battleship']);
export const RTEToolbarLoadingButton = props => {
  return /*#__PURE__*/_jsx(StyledTextToolbarLoadingButton, Object.assign({}, props, {
    className: classNames(props.className, RTE_TOOLBAR_BUTTON_CLASS)
  }));
};